<style lang="scss">
.m1.slide-14 {
  background-image: url(../../../assets/module1/slide14/background-14.jpg);
  background-position: center;
  background-size: cover;
  padding-top: 90px;
  padding-right: 172px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  height: calc(100% - 90px);
  h1 {
    font-size: 87px;
    display: inline-block;
    text-align: center;
    color: #68378d;
    span {
      color: #301e48;
      font-size: 117px;
    }
  }
  p {
    color: white;
    max-width: 887px;
    margin-bottom: 60px;
  }
  h2 {
    font-size: 54px;
    display: flex;
    flex-direction: column;
    width: 600px;
    line-height: 65px;
    transform: rotate(-5deg);
    margin-right: 80px;
    & > span {
      display: block;
      margin-left: auto;
      span {
        color: #fde38f;
      }
    }
  }
  p:last-of-type {
    margin-top: 20px;
  }
}
</style>

<template>
  <div class="slide-14 m1">
    <transition name="fadeLeft" appear>
      <img
        v-show="slideIndex == 13"
        src="@/assets/module1/slide14/photo-14.png"
        class="chars"
      />
    </transition>
    <transition name="fadeUp" appear>
      <h1 v-show="slideIndex == 13" v-html="$t('module1.slide14.heading')"></h1>
    </transition>
    <transition name="fadeUp" appear>
      <p v-show="slideIndex == 13" class="delay-1">
        {{ $t("module1.slide14.paragraph") }}
      </p>
    </transition>
    <transition name="fadeUp" appear>
      <div v-show="slideIndex == 13" class="delay-2">
        <h2 v-html="$t('module1.slide14.paragraph2')"></h2>
      </div>
    </transition>
    <transition name="fadeUp" appear>
      <p v-show="slideIndex == 13" class="delay-3">
        {{ $t("module1.slide14.outro") }}
      </p>
    </transition>
  </div>
</template>

<script>
export default {
  props: ["slideIndex"]
};
</script>
